<template>
  <v-app>
    <v-app-bar app :color="getHeaderColor()" dark height="125px">
      <v-img
        :src="require('@/assets/images/logo/logo-wit.webp')"
        class="my-3 m-4 p-6 mr-4 pr-0 logo h-full"
        max-width="200px"
        contain
        @click="navigateTo('Options')"
        style="cursor: pointer"
      />
      <div class="d-flex align-center">
        <h2 class="text-xl font-bold">
          Planbord
          <span class="text-sm" v-if="isDevelopment">Ontwikkelmodus</span>
        </h2>
      </div>

      <v-spacer></v-spacer>

      <p class="subtitle-1 font-weight-medium my-3 mx-3">
        {{ loggedInName }} ({{ loggedInDepartment }})
      </p>
      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on" class="mr-1">
            <v-avatar size="40" color="secondary">
              {{ loggedInName | truncate(2) }}
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, i) in userprofile"
            :key="i"
            :to="item.to"
            @click="callMethod(item.method)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Base",
  data: () => ({
    userprofile: [
      { title: "Instellingen", method: "openSettings" },
      { title: "Uitloggen", method: "logout" },
    ],
  }),
  computed: {
    ...mapGetters({
      isDevelopment: "tools/getIsDevelopment",
      serverEnvironment: "tools/getServerEnvironment",
    }),
    loggedInName() {
      let currentUser = this.$auth.user();
      if (currentUser == null) return "";
      return currentUser.fullname.replace(/ /g, "") == ""
        ? currentUser.email
        : currentUser.fullname;
    },
    loggedInDepartment() {
      let currentUser = this.$auth.user();
      if (currentUser == null) return "";
      return currentUser.department;
    },
  },
  methods: {
    logout: function () {
      this.$auth.logout();
    },
    navigateTo(name) {
      this.$router.push({ name: name });
    },
    openSettings: function () {
      this.$router.push("/instellingen");
    },
    callMethod: function (method) {
      if (method == "logout") this.logout();
      else if (method == "openSettings") this.openSettings();
    },
    getHeaderColor() {
      let serverEnv = this.serverEnvironment.toLowerCase();
      let clientEnv = this.isDevelopment ? "development" : "production";

      if (serverEnv == "production" && clientEnv == "development")
        return "error";

      return "primary";
    },
    fetchCurrentUser() {
      this.$store
        .dispatch("planners/fetchCurrentPlanner")
        .then((result) => {
          let currentUser = this.$auth.user();
          if (this.isEmptyObject(currentUser)) {
            this.$auth.user(result);
          }
        })
        .catch(function () {
          this.$auth.user(null);
        });
    },
  },
};
</script>
